export default {
  // 授课码登录
  courseLogin: '/local/miniprogram/elf_login.php',
  // 切换clientid
  switchClienId: {
    url: '/webservice/rest/server.php',
    wsfunction: 'local_miniprogram_elf_change_clientid'
  }
}
